module.exports = __webpack_public_path__ + "static/media/ios-2.036c63e5.jpg";